const textFields = ["text", "email", "tel", "number", "password"];
const otherFields = [
  "date",
  "checkbox",
  "radioGroup",
  "autoComplete",
  "multiSelect"
];

const isTextfield = type => textFields.includes(type);
const isField = type => [...textFields, ...otherFields].includes(type);

export { isTextfield, isField };
